/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { CategoryQuery as SourceCategoryQuery } from 'SourceQuery/Category.query';

/** @namespace Bookland/Query/Category/Query */
export class CategoryQuery extends SourceCategoryQuery {
    _getDefaultFields() {
        return [
            'id',
            'url',
            'name',
            'alternative_name',
            'image',
            'url_key',
            'url_path',
            'is_active',
            'meta_title',
            'description',
            'canonical_url',
            'product_count',
            'meta_keywords',
            'default_sort_by',
            'meta_description',
            'landing_page',
            'display_mode',
            'is_anchor',
            this._getCmsBlockField(),
            this._getBreadcrumbsField()
        ];
    }
}

export default new CategoryQuery();
